import { PRODUCTION } from 'constants';
import { useSession } from 'hooks/use_context';
import React, { useEffect } from 'react';

import './with_json_form_helpers.scss';
import { useRequest } from 'components/wizard/context/request/hook';
import copy from 'clipboard-copy';
import { useApplication } from 'hooks/use_application';
import JsonFormEditor from 'components/ui/json_form_editor';

const withJsonFormHelpers = (WrappedComponent) => {
  return (props) => {
    const { requestData } = useRequest();
    const { isSuperAdmin } = useSession();
    const { debugJsonForm } = useApplication();

    const addTooltip = (element) => {
      if (element.classList.contains('tooltipJsonFormHelper-processed')) {
        return;
      }
      var tooltipSpan = document.createElement('span');
      tooltipSpan.classList.add('tooltipJsonFormHelperText');
      tooltipSpan.innerText = element.getAttribute('data-name');
      tooltipSpan.title = 'Cliquer pour copier';
      tooltipSpan.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        copy(tooltipSpan.innerText);
        var dataName = element.getAttribute('data-name');
        tooltipSpan.innerText = 'Copié !';
        tooltipSpan.classList.add('copied');
        setTimeout(function () {
          tooltipSpan.innerText = dataName;
          tooltipSpan.classList.remove('copied');
        }, 1200);
      });
      element.classList.add('tooltipJsonFormHelper', 'tooltipJsonFormHelper-processed');
      element.appendChild(tooltipSpan);
    };

    const removeTooltips = () => {
      var elementsWithTooltip = document.querySelectorAll('.tooltipJsonFormHelper-processed');

      elementsWithTooltip.forEach(function (element) {
        var tooltipSpan = element.querySelector('.tooltipJsonFormHelperText');
        if (tooltipSpan) {
          element.removeChild(tooltipSpan);
        }
        element.classList.remove('tooltipJsonFormHelper', 'tooltipJsonFormHelper-processed');
      });
    };

    useEffect(() => {
      if (PRODUCTION || !isSuperAdmin) {
        return;
      }
      if (!debugJsonForm) {
        removeTooltips();
        return;
      }
      const initialScanTimeout = setTimeout(() => {
        document.querySelectorAll('[data-name]').forEach(addTooltip);
      }, 500);
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return;
            if (node.matches && node.matches('[data-name]')) {
              addTooltip(node);
            }
            if (node.querySelectorAll) {
              node.querySelectorAll('[data-name]').forEach(addTooltip);
            }
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
      return () => {
        clearTimeout(initialScanTimeout);
        observer.disconnect();
      };
    }, [requestData, debugJsonForm, isSuperAdmin]);

    return (
      <JsonFormEditor>
        <WrappedComponent {...props} />
      </JsonFormEditor>
    );
  };
};

export default withJsonFormHelpers;
